/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { Dropdown, Button, Skeleton, Avatar } from "antd";
import { useGetUserTypeQuery } from "../../redux/api/user";
import { useDispatch } from "react-redux";
import { setAuthenticated } from "../../redux/store/oauthSlice";
import { useNavigate } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import { useAuth0 } from "@auth0/auth0-react";

export default function LoginIcon() {
  const [decodedJwt, setDecodedJwt] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isAuthenticated, logout, getIdTokenClaims } = useAuth0();

  const currentUrlPath = window.location.pathname;

  const userType = useGetUserTypeQuery();

  useEffect(() => {
    const getToken = async () => {
      if (isAuthenticated) {
        try {
          const idToken = await getIdTokenClaims();
          const jwtData = jwtDecode(idToken.__raw);
          setDecodedJwt(jwtData);
        } catch (error) {
          console.error('Error decoding token:', error);
        }
      }
    };
    getToken();
  }, [isAuthenticated, getIdTokenClaims]);

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
    dispatch(setAuthenticated(false));
  };

  const menuItems = [
    {
      key: "1",
      label: (
        <a>{user?.name || <Skeleton block button size="small" />}</a>
      ),
    },
    {
      key: "2",
      label: <a>{userType.data}</a>,
    },
    {
      key: "3",
      label: <a onClick={handleLogout}>Logout</a>,
    },
  ];

  return (
    <>
      <Dropdown
        placement="topRight"
        menu={{
          items: menuItems,
        }}
        style={{
          display: "flex",
          justifyContent: "right",
          backgroundColor: "blue",
          border: "0px",
          position: "relative",
          height: "100%",
          alignItems: "center",
        }}
      >
        <Button
          variant="solid"
          style={{
            border: "0px",
            width: "2.5rem",
            height: "88%",
            backgroundColor: "transparent",
            borderRadius: "var(--co-radius) 0px var(--co-radius) 0px",
            boxShadow: "0px 0px 0px 0px",
          }}
        >
          <div
            style={{
              color: "white",
              position: "relative",
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                position: "absolute",
                width: "10px",
                height: "10px",
                backgroundColor: "var(--green-color)",
                borderRadius: "50%",
                bottom: "0px",
                right: "-2px",
                opacity: 0.95,
                zIndex: "100",
                outline:
                  currentUrlPath === "/"
                    ? "4px solid var(--primary-color)"
                    : "4px solid var(--secondary-color)",
              }}
            />
            {user?.picture ? (
              <img
                style={{
                  height: "2.5rem",
                  width: "2.5rem",
                  borderRadius: "var(--co-radius) 0px var(--co-radius) 0px",
                  overflow: "hidden",
                }}
                src={user.picture}
                alt={"user avatar"}
              />
            ) : (
              <Avatar
                icon={<UserOutlined />}
                style={{
                  height: "2.5rem",
                  width: "2.5rem",
                  borderRadius: "var(--co-radius) 0px var(--co-radius) 0px",
                  backgroundColor: "var(--dark-green-color)",
                }}
              />
            )}
          </div>
        </Button>
      </Dropdown>
    </>
  );
}